import { useContext } from "react";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import LoginPage from "../pages/public-page/auth-page/login/Login";
// import SignupPage from "../pages/public-page/auth-page/signup/Signup";
import NotFound from "../pages/error-page/NotFound";
import MainLayout from "../pages/protected-page/MainLayout";
import Support from "../pages/protected-page/ho-tro/Page";
import EditHistory from "../pages/protected-page/lich-su/lich-su-chinh-sua/Page";
import PaymentHistory from "../pages/protected-page/lich-su/lich-su-thanh-toan/Page";
import ManageService from "../pages/protected-page/quan-ly-dich-vu/Page";
import ManageCustomer from "../pages/protected-page/quan-ly-khach-hang/Page";
import CustomerInfo from "../pages/protected-page/quan-ly-khach-hang/components/CustomerInfo";
import AuthLayout from "../pages/public-page/auth-page/layout";
// import DetailDocument from "../pages/protected-page/quan-ly-dich-vu-khach-hang/components/DetailDocument";
import { AuthContext } from "../contexts/AuthContext";
import CommonReport from "../pages/protected-page/bao-cao-thong-ke/components/CommonReport";
import FinancialReport from "../pages/protected-page/bao-cao-thong-ke/components/FinancialReport";
import IntellectualPropertyReport from "../pages/protected-page/bao-cao-thong-ke/components/IntellectualPropertyReport";
import ProfileReport from "../pages/protected-page/bao-cao-thong-ke/components/ProfileReport";
import ServiceReport from "../pages/protected-page/bao-cao-thong-ke/components/ServiceReport";
import ListProposalsForApproval from "../pages/protected-page/danh-sach-ho-so-de-xuat-duyet/Page";
import DetailCategory from "../pages/protected-page/loai-dich-vu/DetailCategory";
import EditCategory from "../pages/protected-page/loai-dich-vu/EditCategory";
import ListCategory from "../pages/protected-page/loai-dich-vu/Page";
import DocumentMangement from "../pages/protected-page/mua-ban-so-huu-tri-tue/Page";
import PostsMangement from "../pages/protected-page/quan-ly-bai-viet/Page";
import PostsDetail from "../pages/protected-page/quan-ly-bai-viet/components/ProcedureDetail";
import BannerManagement from "../pages/protected-page/quan-ly-banner/BannerManagement";
import BannerDetail from "../pages/protected-page/quan-ly-banner/components/BannerDetail";
import CreateNewService from "../pages/protected-page/quan-ly-dich-vu-khach-hang/CreateNewService";
import VatConfig from "../pages/protected-page/quan-ly-dich-vu/VATConfig";
import DetailForm from "../pages/protected-page/quan-ly-dich-vu/components/DetailForm";
import DetailService from "../pages/protected-page/quan-ly-dich-vu/components/DetailService";
import EditProfile from "../pages/protected-page/quan-ly-dich-vu/components/EditProfile";
import OrderManagement from "../pages/protected-page/quan-ly-don-hang/Page";
import DocumentManager from "../pages/protected-page/quan-ly-ho-so/Page";
import DetailDepartment from "../pages/protected-page/quan-ly-phong-ban/components/DetailDepartment";
import DepartmentManager from "../pages/protected-page/quan-ly-phong-ban/page";
import StaffList from "../pages/protected-page/quan-ly-tai-khoan/danh-sach-tai-khoan/Page";
import UserInfo from "../pages/protected-page/quan-ly-tai-khoan/danh-sach-tai-khoan/UserInfo";
import UserProfile from "../pages/protected-page/quan-ly-tai-khoan/tai-khoan-cua-toi/Page";
import ProcedureMangement from "../pages/protected-page/quan-ly-thu-tuc/Page";
import ProcedureDetail from "../pages/protected-page/quan-ly-thu-tuc/components/ProcedureDetail";
import DetailTicket from "../pages/protected-page/ticket/DetailTicket";
import EditTicket from "../pages/protected-page/ticket/EditTicket";
import ForgotPasswordPage from "../pages/public-page/auth-page/forgot-password/forgot-password";
import HomeRedirect from "./HomeRedirect";

const AppRoutes = () => {
  const { token } = useContext(AuthContext);

  const RequireAuth = ({ children }) => {
    return token ? children : <Navigate to="/login" />;
  };
  return (
    <Router
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        <Route
          element={
            <RequireAuth>
              <MainLayout />
            </RequireAuth>
          }
        >
          <Route path="/" element={<HomeRedirect />} />
          <Route path="/quan-ly-banner" element={<BannerManagement />} />
          <Route path="/quan-ly-banner/banner/:id" element={<BannerDetail />} />
          
          <Route path="/quan-ly-khach-hang" element={<ManageCustomer />} />
          <Route
            path="/quan-ly-khach-hang/khach-hang/:id"
            element={<CustomerInfo />}
          />
          <Route path="/quan-ly-ho-so" element={<DocumentManager />} />
          <Route path="/quan-ly-dich-vu" element={<ManageService />} />
          <Route path="/loai-dich-vu" element={<ListCategory />} />
          <Route path="/loai-dich-vu/:id" element={<DetailCategory />} />
          <Route path="/cau-hinh-vat" element={<VatConfig />} />
          <Route
            path="/loai-dich-vu/:id/chinh-sua"
            element={<EditCategory />}
          />
          <Route
            path="/quan-ly-dich-vu/dich-vu/:id"
            element={<DetailService />}
          />
          <Route
            path="/quan-ly-khach-hang/:id/tao-moi/:slug/:serviceId"
            element={<CreateNewService />}
          />
          <Route
            path="/quan-ly-dich-vu-khach-hang/ho-so/:id"
            element={<DetailForm />}
          />
          <Route
            path="/quan-ly-dich-vu-khach-hang/ho-so/:id/chinh-sua"
            element={<EditProfile />}
          />
          <Route
            path="/quan-ly-khach-hang/ticket/:id"
            element={<DetailTicket />}
          />
          <Route
            path="/quan-ly-khach-hang/ticket/:id/chinh-sua"
            element={<EditTicket />}
          />
          <Route path="/quan-ly-phong-ban" element={<DepartmentManager />} />
          <Route path="/quan-ly-phong-ban/:id" element={<DetailDepartment />} />

          <Route path="/lich-su-thanh-toan" element={<PaymentHistory />} />
          <Route path="/lich-su-chinh-sua" element={<EditHistory />} />
          <Route path="/ho-tro" element={<Support />} />
          <Route path="/quan-ly-thu-tuc" element={<ProcedureMangement />} />
          <Route
            path="/quan-ly-thu-tuc/thu-tuc/:id"
            element={<ProcedureDetail />}
          />
          <Route path="/tra-cuu" element={<PostsMangement />} />
          <Route path="/tra-cuu/bai-viet/:id" element={<PostsDetail />} />

          <Route
            path="/mua-ban-so-huu-tri-tue"
            element={<DocumentMangement />}
          />

          <Route
            path="/quan-ly-tai-lieu"
            element={<PostsMangement />}
          />

          <Route
            path="/quan-ly-xet-duyet"
            element={<ListProposalsForApproval />}
          />

          <Route path="/quan-ly-don-hang" element={<OrderManagement />} />

          <Route path="/bao-cao-tong-quan" element={<CommonReport />} />

          <Route path="/bao-cao-dich-vu" element={<ServiceReport />} />

          <Route path="/bao-cao-ho-so" element={<ProfileReport />} />

          <Route
            path="/danh-muc-tai-san-tri-tue"
            element={<IntellectualPropertyReport />}
          />

          <Route path="/bao-cao-tai-chinh" element={<FinancialReport />} />

          <Route path="/tai-khoan-cua-toi" element={<UserProfile />} />

          <Route path="/danh-sach-tai-khoan" element={<StaffList />} />
          <Route
            path="/danh-sach-tai-khoan/tai-khoan/:id"
            element={<UserInfo />}
          />

          <Route
            path="/danh-sach-tai-khoan/tai-khoan/:id/chinh-sua"
            element={<UserInfo mode="edit" />}
          />
          <Route
            path="/danh-sach-tai-khoan/tao-tai-khoan-moi"
            element={<UserInfo mode="create" />}
          />
        </Route>
        <Route element={token ? <Navigate to="/" /> : <AuthLayout />}>
          <Route path="/login" element={<LoginPage />} />
          {/* <Route path="/signup" element={<SignupPage />} /> */}
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        </Route>
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
